import { render, staticRenderFns } from "./PublishSuccess.vue?vue&type=template&id=cb87fcae&scoped=true&"
var script = {}
import style0 from "./PublishSuccess.vue?vue&type=style&index=0&id=cb87fcae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb87fcae",
  null
  
)

export default component.exports